import { _ } from 'utils'
import { createEventRoute } from 'utils/routes'
import SpacesOverview from './SpacesOverview'

export default {
    virtualSpaces: createEventRoute({
        title: _('portal_menu.spaces', {}, false),
        breadcrumb: _('portal_menu.spaces', {}, false),
        component: SpacesOverview,
        path: '/',
        exact: true,
        context: 'virtual-spaces'
    }),
    spacesOverview: createEventRoute({
        title: _('portal_menu.space_overview', {}, false),
        path: '/overview',
        component: SpacesOverview,
        exact: true,
        context: 'virtual-spaces-overview'
    })
}
